import { Chakra } from "@airhelp/react-ui-components";
import type { CompensationFeeCardsProps } from "./CompensationFeeCards.d";
import { CompensationFeeCard } from "./CompensationFeeCard/CompensationFeeCard";

const { Flex } = Chakra;

const CompensationFeeCards = ({ cards }: CompensationFeeCardsProps) => (
  <Flex
    width="full"
    direction={{ base: "column", lg: "row" }}
    border="1px"
    borderColor="greyscale.400"
    borderRadius="lg"
    overflow="hidden"
  >
    {cards.map(({ ...card }) => (
      <CompensationFeeCard key={card._uid} {...card} />
    ))}
  </Flex>
);

export default CompensationFeeCards;
